import { Component, OnInit } from '@angular/core';

import { getObjectiveVehiclesSelectors } from 'src/app/modules/objective/store/objective.selectors';
import { IObjectivesFormState } from 'src/app/modules/objective/store/objective.state';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { formatDate } from 'src/app/utils/format-date';
import { formatCurrency } from 'src/app/utils/format-currency';

@Component({
  selector: 'app-pdf-vehicles',
  templateUrl: './pdf-vehicles.component.html',
  styleUrls: ['./pdf-vehicles.component.scss'],
})
export class PdfVehiclesComponent implements OnInit {
  dataStoreVehicles$: Observable<any>;
  dataStoreVehicles: IObjectivesFormState;
  intendDate: any;
  minInvestimentFormated: string;
  maxInvestimentFormated: string;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.getState();
  }

  getState() {
    this.dataStoreVehicles$ = this.store.select(getObjectiveVehiclesSelectors);
    this.dataStoreVehicles$.subscribe((value) => {
      this.dataStoreVehicles = {
        ...(this.dataStoreVehicles = value),
      };
    });

    this.intendDate = this.dataStoreVehicles.date;

    if (this.intendDate) {
      this.intendDate = formatDate(this.intendDate);
    } else {
      this.intendDate = 'data não especificada!';
    }
    this.minInvestimentFormated = formatCurrency(
      this.dataStoreVehicles.minimumInvestment
    );
    this.maxInvestimentFormated = formatCurrency(
      this.dataStoreVehicles.maximumInvestment
    );
  }
}
